import { NavigateNext } from '@mui/icons-material'
import { Icon, SvgIconProps } from '@mui/material'
import clsx from 'clsx'
import { useAuth } from 'contexts/auth'
import { useSidebar } from 'contexts/sidebar'
import { Fragment, ReactElement, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import getIconComponent from 'utils/get-icon-mui'
import { useStyles } from './styles'
interface ISidebarDefaultItemProps {
  idn: string
  icon: ReactElement<SvgIconProps> | string
  route?: string
  label?: string
  disabled?: boolean
  workspace?: boolean
  direction?: boolean
  routes?: string[]
  handleClick?: () => void
}

const SideBarItem = ({
  idn,
  icon,
  route,
  routes,
  label = '',
  disabled = false,
  direction = false,
  workspace = false,
}: ISidebarDefaultItemProps) => {
  const { expanded, menuOptions, onSelectSubMenuOption, selectedSubMenu, organizationOptions } = useSidebar()
  const { user } = useAuth()
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const rootClass = !expanded ? classes.root : classes.rootExtended
  const disabledClass = disabled && classes.rootDisabled

  let activeClass =
    (location.pathname === route || idn === selectedSubMenu.id) &&
    location.pathname != '/soon' &&
    (!expanded ? classes.rootActive : classes.rootActiveExtended)

  if (location.pathname !== '/soon') {
    if (routes) {
      const currentRoute: string = location.pathname.split('/')[1]

      if (currentRoute) {
        activeClass = routes.includes(currentRoute) && (expanded ? classes.rootActiveExtended : classes.rootActive)
      }
    }
  }

  const handleItemClick = () => {
    const isWithinRange = (idn: string) => parseInt(idn) >= 900 && parseInt(idn) <= 999
    const shouldOpenExternalLink = (route: string | undefined) => route && route.length > 4 && route.includes('http')
    const shouldRedirectContract = () =>
      workspace && user && !user.isSeller && !user.isAdmin && organizationOptions.length === 1

    if (isWithinRange(idn)) {
      if (shouldRedirectContract()) {
        console.log(organizationOptions)
        return history.push(`/v2/organizations/${organizationOptions[0].id}/workspaces`)
      } else {
        return history.push(route)
      }
    } else if (shouldOpenExternalLink(route)) {
      return window.open(route, '_blank')
    } else {
      const item = menuOptions.find((option) => option.id === idn)
      if (item) {
        onSelectSubMenuOption(idn)
      }
    }
  }

  const handleMouseChange = () => setIsHovered((prev) => !prev)

  if (typeof icon === 'string') {
    const IconComponent = getIconComponent(icon)

    return (
      <div
        id={idn}
        key={idn}
        onClick={handleItemClick}
        className={clsx(rootClass, disabledClass, activeClass)}
        onMouseEnter={handleMouseChange}
        onMouseLeave={handleMouseChange}
      >
        <span className={clsx(classes.icon, classes.mainIcon)}>
          <IconComponent />
        </span>
        {expanded && (
          <Fragment>
            <h1>{label}</h1>
            {direction && (
              <NavigateNext
                className={clsx(classes.icon, classes.arrowIcon, (isHovered || activeClass) && classes.arrowEnabled)}
              />
            )}
          </Fragment>
        )}
      </div>
    )
  }

  return (
    <div
      id={idn}
      key={idn}
      onClick={handleItemClick}
      className={clsx(rootClass, disabledClass, activeClass)}
      onMouseEnter={handleMouseChange}
      onMouseLeave={handleMouseChange}
    >
      <Icon className={clsx(classes.icon, classes.mainIcon)}>{icon}</Icon>
      {expanded && (
        <Fragment>
          <h1>{label}</h1>
          {direction && (
            <NavigateNext
              className={clsx(classes.icon, classes.arrowIcon, (isHovered || activeClass) && classes.arrowEnabled)}
            />
          )}
        </Fragment>
      )}
    </div>
  )
}

export default SideBarItem
